<template>
  <header class="text-center top-bar d-flex p-0 px-md-3 py-1 mb-md-3" :class="{ 'light-top-bar': isPublicVersion }">
    <nav class="navbar navbar-expand-md navbar-light bg-none flex-grow-1 py-0">
      <router-link tag="a" to="/" class="navbar-brand">
        <img
          src="../../assets/svg/logo-text.svg"
          class="d-none d-md-inline-block mx-auto main-logo"
          alt="Refera"
          v-if="isPublicVersion"
        />
        <img
          v-else
          src="../../assets/svg/logo-light.svg"
          class="d-none d-md-inline-block mx-auto main-logo"
          alt="Refera"
        />
        <img src="../../assets/svg/logo-light.svg" height="30" class="d-inline-block d-md-none" alt="Refera" />
      </router-link>
      <template v-if="isLoggedIn && isDashboardNavVisible">
        <div class="collapse navbar-collapse h-100" id="navbarNav">
          <ul class="navbar-nav h-100 w-100">
            <router-link to="/" v-slot="{ href, route, navigate, isActive, isExactActive }">
              <li class="nav-item" :class="{ active: isExactActive || ['referral-view'].includes($route.name) }">
                <a :href="href" class="nav-link" :class="{ active: isExactActive }"
                  >Referrals
                  <span
                    class="badge badge-info ml-1 badge-dot"
                    v-if="needsActionCount && !isActive && !$store.state.settings.isSidebarEnabled"
                  >
                    <!-- {{
                      Math.min(99, needsActionCount) +
                      (needsActionCount > 99 ? '+' : '')
                    }} -->
                  </span>
                </a>
              </li>
            </router-link>
            <router-link to="/op-reports" v-slot="{ href, route, navigate, isActive, isExactActive }">
              <li class="nav-item" :class="{ active: isExactActive }">
                <a :href="href" class="nav-link" :class="{ active: isExactActive }">
                  Op Reports
                  <span
                    class="badge badge-info ml-1 badge-dot"
                    v-if="opReportsCount && !$store.state.settings.isSidebarEnabled"
                  >
                    <!-- {{
                      Math.min(99, opReportsCount) +
                      (opReportsCount > 99 ? '+' : '')
                    }} -->
                  </span></a
                >
              </li>
            </router-link>
            <router-link to="/insights" v-slot="{ href, isActive }">
              <li class="nav-item mr-auto" :class="{ active: isActive }">
                <a :href="href" class="nav-link" :class="{ active: isActive }"> Insights </a>
              </li>
            </router-link>
            <li class="nav-item d-none d-md-flex mr-auto" v-if="!isPremium && practice.referrals_remaining < 19">
              <div class="usuage-chart d-flex align-items-center mr-3">
                <donut-chart :value="Math.min(99.99, Math.floor((practice.referrals_remaining / 20) * 100))" />
                <small class="ml-2 text-small" :class="{ 'text-danger': !practice.referrals_remaining }">
                  You have {{ practice.referrals_remaining }} remaining referral{{
                    practice.referrals_remaining == 1 ? '' : 's'
                  }}
                  this period</small
                >
              </div>
              <a @click.prevent="withPremium" class="btn btn-outline-primary"> Upgrade to premium </a>
            </li>
            <!-- <li class="nav-item d-none d-md-flex">
              <router-link v-if="!isOrganization" to="/?tour=referralTour" tag="button" class="btn btn-lg btn-link text-primary-hover when-expanded" style="color:#F8F9F9">
                <font-awesome-icon :icon="['far', 'play-circle']" class="mr-1" />
                Start tour
              </router-link>
            </li> -->
            <li class="nav-item d-none d-md-flex" v-if="practice && practice.specialty > 0">
              <router-link
                v-if="!isOrganization"
                to="/op-report/create"
                tag="button"
                class="btn btn-primary font-weight-bold when-expanded"
                >Send Op Report
              </router-link>
            </li>
            <!-- <li class="nav-item d-none d-md-flex">
              <router-link v-if="!isOrganization" to="/referral/create" tag="button" class="btn btn-lg btn-primary font-weight-bold when-expanded" data-v-tour="createReferral">Create Referral
              </router-link>
            </li> -->
          </ul>
        </div>
        <div class="user-menu-container ml-3">
          <user-menu class="flex-grow-1" :key="user.token" />
        </div>
      </template>
      <div v-else-if="!hideMenu" class="header__login ml-auto">
        <router-link v-if="isLoggedIn" class="btn btn-link btn-lg font-weight-bolder" to="/"
          >Hi {{ user.first_name }}<span class="d-none d-md-inline">, back to dashboard</span>
          <font-awesome-icon :icon="['far', 'angle-right']" class="ml-2" size="lg" />
        </router-link>
        <template v-else>
          <a class="contact-phone d-none d-md-inline" href="tel:8554733372">1 (855) 473 3372</a>
          <router-link
            class="btn header__btn-signup"
            to="/register"
            v-if="$route && $route.name && !$route.name.startsWith('Register')"
            >Sign up</router-link
          >
          <router-link
            class="btn header__btn-login ml-3"
            to="/login"
            v-if="$route && $route.name && !$route.name.startsWith('Login')"
            >Login</router-link
          >
        </template>
      </div>
      <!-- <div v-if="isLoggedIn && isOrganization" class="header__login ml-auto">
        <a
          href="javascript:void(0)"
          class="btn header__btn-signup"
          @click="$store.dispatch('auth/logout')"
          >Logout</a
        >
      </div> -->
    </nav>
  </header>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import DonutChart from '../shared/DonutChart.vue'
import UserMenu from './UserMenu'
export default {
  props: ['showUsers', 'hideMenu', 'isPublicVersion'],
  components: { UserMenu, DonutChart },
  data() {
    return { alert: null } //todo: errors and alerts from vuex
  },
  computed: {
    ...mapState('auth', {
      user: (state) => state.user,
      isLoginBarVisible: (state) => !!state.logins.length,
      logins: (state) => state.logins.filter((s) => s.id != state.user.id),
    }),

    ...mapGetters('billing', ['isPremium']),
    ...mapGetters('auth', ['isLoggedIn', 'isOrganization']),

    ...mapGetters('notifications', {
      errorList: 'errors',
      successList: 'success',
      infoList: 'info',
    }),

    ...mapState('conferences', ['conference']),

    ...mapState('settings', ['isSidebarEnabled']),

    needsActionCount() {
      return this.isLoggedIn && this.$store.getters['referrals/filterCount']('Needs Action')
    },

    opReportsCount() {
      return (
        this.isLoggedIn &&
        this.$store.state.opreports.opReports &&
        this.$store.state.opreports.opReports.filter((s) => s.is_incoming).length
      ) //todo: incoming unread only
    },

    practice() {
      return this.user && this.user.practice
    },

    isPracticeActive() {
      return this.isLoggedIn && this.user.practice.status == 1 && this.user.practice.is_setup_complete
    },

    isDashboardNavVisible() {
      return (!this.hideMenu && !this.$route.meta.isPublic) || this.$route.meta.showMenuWhenLoggedIn
    },
  },
  methods: {
    signOut() {
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>

<style scoped lang="scss">
.top-bar {
  /* box-shadow: 0px 2px 3px rgba(202, 202, 202, 0.2); */
  // z-index: 10;
  background: #012b30;
  color: #fff;
  font-size: 1rem;
}
.user-menu-container {
}
.alert {
  margin: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.btn-light.dropdown-toggle {
  padding: 1em 0;
}
.btn-light.dropdown-toggle::after {
  display: none;
}
.btn-light.dropdown-toggle:hover,
.btn-light.dropdown-toggle:focus,
.btn-light.dropdown-toggle:active {
  background-color: #fefefe;
}

.nav-item {
  // font-size: 1.275em;
  display: flex;
  align-items: center;
  padding: 0em 0.85rem;
}

.navbar-light .navbar-nav .nav-link {
  color: var(--light-color);
  display: flex;
  align-items: center;
}
.navbar-light .navbar-nav .nav-item.active .nav-link {
  /* border-bottom: 3px solid #1cacda; */
  color: var(--primary-color);
}
.nav-item:last-child {
  padding-right: 0;
}
.navbar-brand {
  margin-right: 0rem;
}
.main-logo {
  height: 30px;
}
@media (min-width: 1200px) {
  .navbar-brand {
    margin-right: 1rem;
  }
  .nav-item {
    padding: 0em 1rem;
  }
  .main-logo {
    height: 30px;
  }
}

.top-bar.light-top-bar {
  background: #ffffffe6;
  margin: 0 !important;
  padding: 0 !important;
  padding: 10px 10% !important;
  // position: absolute;
  width: 100%;
  z-index: 9;
  .navbar {
    padding: 0 !important;
  }

  .header__login .contact-phone {
    color: var(--body-color);
    font-size: 1rem;
    font-weight: bold;
    margin-right: 36px;
    -webkit-transition: 0.3s ease all;
    transition: 0.3s ease all;
  }
  .header__login .btn:not(.btn-link) {
    font-size: 12px;
    line-height: 20px;
    padding: 4px 18px;
    border: 1px solid var(--primary-color);
    border-radius: 5px;
    background: #ffffffe6;
  }
  .header__login .header__btn-signup {
    color: var(--primary-color);
    // margin-right: 18px;
    -webkit-transition: 0.3s ease all;
    transition: 0.3s ease all;
  }
  .header__login .btn.header__btn-login {
    color: var(--primary-color);
    -webkit-transition: 0.3s ease all;
    transition: 0.3s ease all;
  }
}

@media (min-width: 576px) {
  .top-bar.light-top-bar {
    background: #ffffffe6;
    margin: 0 !important;
    padding: 0 !important;
    padding: 20px 10% !important;
  }
}

@media (min-width: 768px) {
  .top-bar.light-top-bar {
    background: #ffffffe6;
    margin: 0 !important;
    padding: 0 !important;
    padding: 30px 10% !important;
  }
}

@media (min-width: 962px) {
  .top-bar.light-top-bar .header__login .btn:not(.btn-link) {
    font-size: 16px;
    line-height: 28px;
    padding: 9px 36px;
  }
}

.badge-dot {
  width: 0.2rem;
  height: 0.2rem;
  padding: 0.2rem;
  min-height: 0.2rem;
  border-radius: 0.2rem;
  line-height: 0.2rem;
  display: inline-block;
  font-size: 0;
  margin-top: -0.5rem;
}
</style>
